import { IAppState } from '../../../../AppModulesWrapper';

export const selectIsChangePackageDisable = (state: IAppState): boolean => {
  return state.servicePickerWidgetV2.publicationPackages.disabled;
};
